import { Permission } from '@app/Permission';
import { useAuth } from '@components/AuthProvider';
import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { ILoading } from '@hooks/useLoading';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { ControlePermissao } from '@mod/ControlePermissao';
import { IUsuario } from '@model/Usuario';
import { EnumUsuarioStatus } from '@model/UsuarioStatus';
import { useUsuarioService } from '@services/UsuarioService';
import { AxiosResponse } from 'axios';
import React from 'react';
import { UsuarioEditarModal } from './UsuarioEditarModal';
import { UsuarioResetarSenhaModal } from './UsuarioResetarSenhaModal';

export type UsuarioMenuProps = {
    menu: IMenu
    usuario: IUsuario
    commandLoading: ILoading
    onUsuarioAtualizado: (usuario: AxiosResponse<IUsuario>) => void
}

export function UsuarioMenu ({ menu, commandLoading, usuario, onUsuarioAtualizado }: UsuarioMenuProps) {
    const message = useMessage();
    const usuarioService = useUsuarioService();

    const resetarSenhaModal = useModalWindow();
    const editarModal = useModalWindow();
    const controlePermissaoModal = useModalWindow();

    const auth = useAuth();

    const handleAlterarStatus = React.useCallback((usuarioStatusId: EnumUsuarioStatus) => () => {
        if (!commandLoading.isLoading) {
            commandLoading.start();
            usuarioService.alterarStatus(usuario.usuarioId, {
                novoStatus: usuarioStatusId
            })
            .then(response => {
                message.success(`Usuário ${response.data.usuarioStatusId === EnumUsuarioStatus.Inativo ? "Inativado" : "Ativado"} com sucesso`);
                onUsuarioAtualizado(response);
            })
            .catch(message.showBlobException)
            .finally(commandLoading.stop);
        }
    }, [commandLoading, message, onUsuarioAtualizado, usuario.usuarioId, usuarioService]);

    return (
        <React.Fragment>
            <RowMenu
                menu={menu}
            >
                <RowMenuItem 
                    key={0} 
                    onClick={menu.handleItemClick(editarModal.open)}
                    text="Editar"
                />

                <RowMenuItem 
                    key={1} 
                    onClick={menu.handleItemClick(resetarSenhaModal.open)}
                    text="Resetar Senha"
                />

                <RowMenuItem 
                    key={2} 
                    onClick={menu.handleItemClick(handleAlterarStatus(usuario.usuarioStatusId === EnumUsuarioStatus.Inativo ? EnumUsuarioStatus.Ativo : EnumUsuarioStatus.Inativo))}
                    text={usuario.usuarioStatusId === EnumUsuarioStatus.Inativo ? "Ativar" : "Desativar"}
                />

                {
                    auth.hasPermission(Permission.Dev) && (
                        <RowMenuItem 
                            key={3} 
                            onClick={menu.handleItemClick(controlePermissaoModal.open)}
                            text="Abrir Controle de Permissão"
                        />
                    )
                }
            </RowMenu>

            <UsuarioResetarSenhaModal 
                modal={resetarSenhaModal}
                usuario={usuario}
                onUsuarioAtualizado={onUsuarioAtualizado}
            />

            <UsuarioEditarModal 
                modal={editarModal}
                usuario={usuario}
                onUsuarioAtualizado={onUsuarioAtualizado}
            />
 
            <ControlePermissao 
                modal={controlePermissaoModal}
                usuario={usuario}
            />
        </React.Fragment>
    )
}